import React, { forwardRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { MDBBtn, MDBCheckbox, MDBIcon, MDBModalFooter, MDBSelect, MDBSpinner, MDBTable, MDBTableBody, MDBTableHead, MDBTextArea } from "mdb-react-ui-kit";
import { deleteUser } from "../../../apiclients/streamsapi_bridge.js";
import { useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import { useForm } from "react-hook-form";
import { getSbProductName } from "../../../apiclients/CommonUtils.js";

const DeleteUser = forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [isloading, setIsloading] = useState(false)
  const [transferAgent, setTransferAgent] = useState("");
  const [deleteReason, setDeleteReason] = useState([]);
  const [storageAgentids, setstorageAgentids] = useState(null);
  const [reasonMessage, setreasonMessage] = useState("")
  const sbProductName = getSbProductName();

  const { register, reset, formState: { isDirty, errors, dirtyFields }, setError, watch, setValue, handleSubmit, clearErrors } = useForm({
    defaultValues: {
      transfer_agent: "",
      delete_reasons: [],
      delete_check: false,
    }
  })

  async function removeThisUser(data) {

    console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
    try {
      if (isDirty) {

        if (data.transfer_agent === "" && !data.delete_check && storageAgentids && storageAgentids.length > 0) {
          setError("transfer_agent", {
            message: "Please select a transfer agent or check the delete box to proceed.",
          });
          return;
        }

        if (data.delete_reasons && data.delete_reasons.some((item) => parseInt(item.id) === 9)) {
          const reasonExists = data.delete_reasons.find(item => parseInt(item.id) === 9);
          const isReasonEmpty = reasonExists ? reasonExists?.delete_reasons_text ? reasonExists?.delete_reasons_text === "" : true : false;
          if (isReasonEmpty) {
            setError("delete_reasons", {
              message: "Please provide the reason",
            });
            return;


          }

        }
        const modifiedData = await prepareFinalJson(dirtyFields, data);
        setIsloading(true);

        if (Object.keys(modifiedData).length > 0) {
          modifiedData.siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
          modifiedData.reqid = 133;
          modifiedData.agentids = props.user;
        }

        console.log("final JSON  ::::::::::::; " + JSON.stringify(modifiedData));
        // debugger;
        let deleteUSer = await deleteUser(modifiedData);
        setTimeout(() => {
          setIsloading(false);
        }, 1000);
        let deleteMsg = await deleteUSer.json();
        // debugger;
        console.log("Response... ");
        console.log(JSON.stringify(deleteMsg));
        // debugger;
        if (deleteMsg.status == "success") {
          localStorage.setItem("s_message", "User removed successfully.");
          // localStorage.setItem(
          //   "user_create_f",
          //   "Something went wrong, Please try again after sometime"
          // );
          // props.onClose();
          // window.location.href = "/userland ing";
        } else if (deleteMsg.message?.errors) {
          deleteMsg.message.errors.forEach((err) => {
            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
          });


        } else {
          localStorage.setItem("f_message", deleteMsg.message);
        }
        if (props.locUser) {
          navigate("/locationsusers", {
            state: { tab: props.locUser },
          });

        } else if (props.groupInfo) {
          navigate("/usersgroups", {
            state: { tab: props.groupInfo },
          });

        } else {
          navigate("/userlanding", {
            state: { tab: "suser", tab2: "suser" },
          });
        }

        window.location.reload();
      }
    } catch (error) {
      console.log("Error :::::::::::: " + error);

    }
  }

  function prepareFinalJson(dirtyFields, data) {
    const modifiedData = {};

    function recurse(dirtyFields, data, modifiedData) {
      for (const field of Object.keys(dirtyFields)) {
        if (dirtyFields[field] && data.hasOwnProperty(field)) {
          if (typeof data[field] === "object" && !Array.isArray(data[field])) {
            modifiedData[field] = {};
            recurse(dirtyFields[field], data[field], modifiedData[field]);
          } else {
            modifiedData[field] = data[field];
          }
        }
      }
    }

    recurse(dirtyFields, data, modifiedData);
    return modifiedData;
  }

  useEffect(() => {
    if (props.deleteReasons && props.deleteReasons.length > 0) {
      setDeleteReason(props.deleteReasons);

    }
    if (props.storageAgents && props.storageAgents.length > 0) {
      const agents = props.storageAgents.map((agent) => ({ text: agent.agent_info, value: agent.agentid }))
      setstorageAgentids(agents);

    }

  }, [props.deleteReasons, props.storageAgents])

  const [checkedItems, setCheckedItems] = useState([]);

  const handleChange = (event) => {
    const { value, checked } = event.target;
    clearErrors("delete_reasons");
    setCheckedItems((prev) =>
      checked ? [...prev, parseInt(value)] : prev.filter((item) => parseInt(item) !== parseInt(value))
    );
    const currentReasons = Array.isArray(watch("delete_reasons")) ? watch("delete_reasons") : [];

    setValue("delete_reasons", (
      checked ? [...currentReasons, { id: parseInt(value) }] : currentReasons.filter((item) => parseInt(item.id) !== parseInt(value))), { shouldDirty: true });

  };


  return (
    <>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}


      {((props.assocCFData && props.assocCFData.length > 0) || (props.assocLunaHops && props.assocLunaHops.length > 0)) ? (
        <>
          {props.assocCFData && props.assocCFData.length > 0 && (
            <div>
              <span className="phrecording">{t("user_associated_cflows")}<br />{props.assocCFData?.map(obj => (' ' + obj.name + ' : ' + obj.extension + ' ')).toString()} </span>
            </div>
          )}
          {props.assocLunaHops && props.assocLunaHops.length > 0 && (
            <div>
              <span className="phrecording">{t("user_associated_lunahops")}<br />{props.assocLunaHops.join(", ")} </span>
            </div>
          )}
          <div style={{ display: "none" }}>
            <button ref={ref} onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              props.onClose();
            }}>
              {t("okay")}</button>
          </div>
        </>

      ) :


        (
          <div>

            <p>You have selected the following user(s) to remove:</p>
            <p>
              <strong>
                {props.agentsName.join(", ") + " - " + props.extension + " "}
              </strong>
              On removing the user(s), addons related information and the Account/Group(s)/ User(s) Voicemail Operator settings will be removed. And the user(s) will be logged-out from ACD if logged in.


            </p>
            {storageAgentids && (
              <>
                <div className="border p-3 my-3 rounded-2" >

                  <p className="fw-bold mb-3">Select any user from the dropdown to move above user(s) content in {sbProductName}.
                    <div className="ms-2 cursor-pointer d-inline deleteUser">
                      <MDBIcon far icon="question-circle" />
                    </div>

                  </p>
                  {storageAgentids && storageAgentids.length > 0 && (
                    <MDBSelect
                      search
                      name="San Jose"
                      size="sm"
                      disabled={watch("delete_check")}
                      data={[{ text: "--Select User--", value: "" }, ...storageAgentids]}
                      value={watch("transfer_agent")}
                      onChange={(e) => {
                        clearErrors("transfer_agent");
                        if (e && e.value) {
                          setValue("transfer_agent", e.value, { shouldDirty: true });
                        }
                      }}
                    />
                  )}
                  {errors.transfer_agent && (
                    <p className="text-danger">{errors.transfer_agent.message}</p>
                  )}
                  <div className="mt-3 d-flex align-items-center">
                    <MDBCheckbox name='flexCheck' checked={watch("delete_check")} id='flexCheckDefault' label=' Remove the selected users content from SmartBox.' onChange={(e) => {
                      const checkValue = e.target.checked;
                      setValue("delete_check", checkValue, { shouldDirty: true });
                      if (checkValue) {
                        setValue("transfer_agent", "", { shouldDirty: true });
                      }

                    }} />
                    <div className="ms-2 cursor-pointer deleteUser">
                      <MDBIcon far icon="question-circle" />
                    </div>
                  </div>
                </div>
                {props.transferMessage && (
                  <p className="fw-bold py-2">
                    {props.transferMessage}:
                  </p>
                )}
              </>)}

            {props.streamletAlertInfo && props.streamletAlertInfo.length > 0 && props.streamletAlertInfo.map((info) => (
              <>
                <MDBTable bordered>
                  <MDBTableHead>
                    <tr>
                      <th scope='col'>Agent id</th>
                      <th scope='col'>Reason</th>
                    </tr>
                  </MDBTableHead>
                  <MDBTableBody>
                    <tr>
                      <td>
                        {info.agentname}
                      </td>
                      <td>
                        {info.stream_number_alert}
                      </td>
                    </tr>
                  </MDBTableBody>
                </MDBTable>




                <p className="fw-bold py-2">
                  Deleting the listed user(s) will unassign the SMS DID(s) associated with the user(s) from their respective Streamlet(s), and the Send SMS functionality will no longer work. Would you like to continue?
                </p>
              </>
            ))}

            <p className="fw-bold py-2">
              Please select one of the reasons for removing the user(s):
            </p>

            <div>
              {deleteReason.map((option, index) => (
                <MDBCheckbox
                  key={index}
                  name='checkboxGroup'
                  value={option.id}
                  label={option.reason}
                  checked={checkedItems.includes(parseInt(option.id))}
                  id={`checkbox${option.id}`}
                  onChange={handleChange}
                />
              ))}
              <MDBCheckbox
                key={9}
                name='checkboxGroup'
                value={9}
                checked={checkedItems.includes(9)}
                label="Other reasons"
                id={`checkbox9`}
                onChange={handleChange}
              />
              <div className="w-100">
                <MDBTextArea
                  disabled={!checkedItems.includes(9)}
                  value={reasonMessage}
                  onChange={(e) => {
                    clearErrors("delete_reasons");
                    const reasonMessage = e.target.value;
                    setreasonMessage(reasonMessage);
                    const currentReasons = Array.isArray(watch("delete_reasons")) ? watch("delete_reasons") : [];
                    const updatedReasons = currentReasons.map((item) =>
                      parseInt(item.id) === 9 ? { ...item, delete_reasons_text: reasonMessage } : item); // Add new reason if not exists
                    setValue("delete_reasons", updatedReasons, { shouldDirty: true });
                    console.log("Updated Reasons:", updatedReasons);



                  }}
                />
                {errors.delete_reasons && (
                  <p className="text-danger">{errors.delete_reasons.message}</p>
                )}
              </div>
            </div>

            {/* // :

        // <div>
        //   <span className="phrecording">{t("RemoveUsertxt")}</span>
        // </div> */}

            {/* <MDBModalFooter>
        <MDBBtn color="secondary" onClick={props.onClose}>
          {t("cancel")}
        </MDBBtn>
        <MDBBtn onClick={(e) => removeThisUser(e)}>{t("remove")}</MDBBtn>
      </MDBModalFooter> */}
            <div style={{ display: "none" }}>
              <button ref={ref} onClick={(e) => { e.preventDefault(); handleSubmit(removeThisUser)() }}>
                {t("add")}</button>
            </div>
            <Tooltip anchorSelect=".deleteUser" place="top" className="exampleTooltip">
              User storage deletion process will take some time.
            </Tooltip>
          </div>
        )}
    </>
  );
});

export default DeleteUser;
